import { ObjectStatus } from '../../../../../entities/objects/constants/object.constants'
import { ObjectItem } from '../../../../../entities/objects/types/object.types'
import { ObjectType } from '../../constants/object-types'

export const createObjectInitialValues = (form: ObjectItem | null) => {
  if (form) {
    return {
      name: form.name,
      address: form.address,
      longitude: form.longitude,
      latitude: form.latitude,
      category: form.category,
      status: ObjectStatus.New,
      structureType: ObjectType.Building,
    }
  }

  return {
    name: '',
    address: '',
    longitude: '',
    latitude: '',
    category: null,
    status: ObjectStatus.New,
    structureType: ObjectType.Building,
  }
}
